import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// assets
import BellOutlined from '@ant-design/icons/BellOutlined';

// project imports
import { useOkunmamisSayisi } from 'api/sakinSayfalari';

// ==============================|| HEADER - BİLDİRİM ROZETİ (Bölüm 2.8) ||============================== //
// Yalnızca Yönetici için mount edilir (bkz. HeaderContent) — endpoint IsYonetici-only,
// Bina Sakini için burada bir role kontrolü YOK, çağıran taraf zaten filtreliyor.

export default function BildirimRozeti() {
  const { sayi } = useOkunmamisSayisi();

  return (
    <Tooltip title="Bildirimler">
      <IconButton
        component={RouterLink}
        to="/bildirimler"
        disableRipple
        color="secondary"
        sx={{ color: 'text.primary', bgcolor: 'grey.100' }}
      >
        <Badge badgeContent={sayi} color="primary">
          <BellOutlined />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
